import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { ticketTracking } from "../../../../redux/action/busAction";
import { PaymentHelper } from "../../PaymentGateway/PaymentHelper";
import { PaymentButton } from "./Paystack.styles";

const Paystack = ({
  passengerInformation,
  allBookingInformation,
  booking_id,
  paydetail,
  paidamount,
  pay_method,
  email,
  phone,
  name,
  setReload,
  setLoading,
  buttonText,   // texte personnalisé du bouton (défaut : "Confirmer le paiement")
}) => {
  const { webSettingData } = useSelector((state) => state.busLists);
  const [paystackData, setPaystackData] = useState(null);
  const fareSummery = useSelector((state) => state?.busLists?.fareSummery);
  const history = useHistory();
  const dispatch = useDispatch();

  /**
   * Enregistre le paiement Paystack côté backend.
   * @param {string} transactionRef - Référence de transaction retournée par Paystack (reference / trxref)
   */
  const paymentLatter = async (transactionRef) => {
    const bookingData = new FormData();

    bookingData.append("booking_id", booking_id);
    // Utiliser la référence Paystack comme paydetail si disponible
    bookingData.append("paydetail", transactionRef || paydetail || "");
    bookingData.append("paidamount", paidamount);
    bookingData.append("pay_method", pay_method);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_MODULE_DOMAIN}/tickets/laterpay`,
        {
          method: "POST",
          body: bookingData,
        }
      );
      const result = await response.json();
      if (result?.status === "success") {
        setReload((preState) => !preState);
        toast.success("Paiement effectué avec succès");
      } else {
        toast.error("Erreur lors de l'enregistrement du paiement.");
      }
    } catch (err) {
      console.error("paymentLatter error", err);
      toast.error("Erreur réseau. Veuillez réessayer.");
    }
  };

  // Paystack exige le montant en sous-unité × 100 pour toutes les devises,
  // y compris XOF (FCFA). Ex : 16 000 FCFA → envoyer 1 600 000.
  const totalPrice = Math.round(
    paidamount ? Number(paidamount) * 100 : Number(fareSummery?.grandTotal) * 100
  );

  const getPaystackData = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_MODULE_DOMAIN}/paymethods/paystack`
    );
    const result = await response.json();

    if (result?.status === "success") {
      setPaystackData(result?.data);
    }
  };

  useEffect(() => {
    try {
      getPaystackData();
    } catch (error) {
      console.error("paystack", error);
    }
  }, []);

  const handleTicketTracking = async (id) => {
    setLoading(false);
    const response = await fetch(
      `${process.env.REACT_APP_API_MODULE_DOMAIN}/tickets/bookingid/${id}`
    );
    const result = await response.json();

    if (result?.status === "success") {
      dispatch(ticketTracking(result?.data));
      history.push(`/ticket-tracking?booking_id=${id}`);
      toast.success("Paiement effectué avec succès");
    }
  };

  const componentProps = {
    email: email ? email : passengerInformation?.login_email,
    amount: totalPrice,
    currency: "XOF",
    metadata: {
      name: name ? name : passengerInformation?.first_name,
      phone: phone ? phone : passengerInformation?.login_mobile,
    },
    publicKey: paystackData?.private_key || "pk_test_79da0ea5fe08fbb185054acecbf73e2ef42cfe71",
    text: buttonText || "Confirmer le paiement",
    onSuccess: (response) => {
      // response contient : reference, trxref, trans, status, message
      const transRef = response?.reference || response?.trxref || response?.trans || "";
      if (booking_id) {
        paymentLatter(transRef);
      } else {
        setLoading(true);
        PaymentHelper({...allBookingInformation, paymentGateway: "paystack", paymentStutas: "Pay Now"}, dispatch)
          .then((res) => {
            const bookingId = res?.data?.booking_id || res?.booking_id || res?.data?.data?.booking_id;
            if (bookingId) {
              handleTicketTracking(bookingId);
            } else {
              history.push("/ticket-tracking");
            }
          })
          .catch((err) => {
            console.error(err);
            history.push("/ticket-tracking");
          });
        // alert("Thanks for doing business with us! Come back soon!!");
      }
    },
    onClose: () => alert("Paiement annulé. Veuillez réessayer."),
  };

  return (
    <PaymentButton
      btnBgColor={webSettingData?.buttoncolor}
      btnBgHvColor={webSettingData?.buttoncolorhover}
      btnTextColor={webSettingData?.buttontextcolor}
      className="paystack-button"
      {...componentProps}
    />
  );
};

export default Paystack;
